var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wizard-progressbar"},[_c('WizardProgressNav',{attrs:{"prev":_vm.prev,"next":_vm.next,"callback":_vm.change_selection}}),_c('WizardProgressStatus',{attrs:{"current":_vm.current}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }